<template>
	<div class="partial partial--home">
		<div class="header__content">
			<h5>Content Types</h5>
		</div>
		<div class="partial__content">
			<div class="models-list">
				<div class="models-list__item" v-for="model in models" :key="model.$key" @click="viewContent(model.$key)">
					<i class="models-list__item-icon icon">{{model.icon}}</i>
					<h5 class="models-list__item-title">{{model.plural}}</h5>
					<div class="models-list__item-nav">
						<a class="models-list__item-nav__item mdc-button" @click="viewContent(model.$key)">View</a>
						<a class="models-list__item-nav__item mdc-button" @click="addItem(model.$key)">Add New</a>
					</div>
				</div>

				<router-link to="/model/" class="models-list__item a" v-if="!models.length">
					<i class="models-list__item-icon icon">add</i>
					<h5 class="models-list__item-title">Add New Model</h5>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	// Dependencies
	import { mapGetters } from 'vuex'

	// Export
	export default {
		name: 'partialHome',
		methods: {
			viewContent(key) {
				this.$router.push({ name: 'contentModel', params: { key } })
			},
			addItem(key) {
				this.$store.dispatch('addItem', key).then(id => {
					this.$router.push({
						name: 'item',
						params: {
							key,
							uid: id,
						},
					})
				})
			},
		},
		computed: {
			...mapGetters([
				'models',
			]),
		},
	}
</script>

<style scoped lang="scss">
	.partial {
		&__content {
			padding: 0 $line;
		}
	}

	.models {
		&-list {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;

			&__item {
				display: flex;
				flex-direction: column;
				flex: 1 0 30%;
				max-width: 33%;
				position: relative;

				@include gutter('margin-top');
				@include gutter('padding-left', 0.5);
				@include gutter('padding-right', 0.5);
				@include gutter('padding-top', 1);

				&::before {
					box-shadow: $whiteframe1;
					border-radius: 3px;
					border-top: 4px solid color_('primary');
					content: ' ';
					position: absolute;
					height: 100%;
					top: 0;
					width: calc(100% - 1.5rem);
					z-index: 0;
				}

				&.a {
					color: color_('primary');
					text-decoration: none;
					&::before {
						transition: background-color 250ms $easing-material;
						will-change: background-color;
					}

					&:hover {
						&::before {
							background-color: color_('background');
						}
					}
				}

				&-icon {
					align-self: center;
					font-size: 48px;
					z-index: 1;
					color: darken(color_('background'), 30);
				}

				&-title {
					align-self: center;
					z-index: 1;
				}

				&-nav {
					//background-color: color_('background');
					border-top: 1px solid darken(color_('background'),3);
					display: flex;
					position: relative;
					z-index: 1;
					justify-content: space-around;
					@include gutter('margin-top',0.25);
					@include gutter('margin-bottom',0.25);
					@include gutter('margin-left',0.25);
					@include gutter('padding-top',0.25);

					&__item {


					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/partials/Home.vue